export default __webpack_public_path__ + "static/media/testimonial_logo_1.7f111b29.svg";